module.exports = __webpack_public_path__ + "media/images/rema-2-f5e52180ddc82072302192191e9d032d.jpg";